import * as React from "react"
import { TouchableOpacity, Text } from "react-native";
import { Icons } from "../../config/icons";
import { KiaIcon } from "../icon/icon";
import * as styles from "./checkbox-style";

export interface CheckboxProps {
    checked: boolean,
    text: string,
    onCheckboxPress: any
}

export function Checkbox(props: CheckboxProps){
    return (
        <TouchableOpacity style={styles.baseView} onPress={() => props.onCheckboxPress(!props.checked)}>
            <KiaIcon src={props.checked ? Icons.checkbox.checked : Icons.checkbox.unchecked} size='medium' />            
            <Text>{props.text}</Text>
        </TouchableOpacity>
    )
}